import { FC, MouseEventHandler, ReactNode } from 'react';

interface  IButton {
  className?: string;
  type?: string;
  children: ReactNode;
  onClick?: MouseEventHandler<HTMLButtonElement>; //тут просто что функция возвращает надо)) () => void
}
/**
 * Button component.
 * @param {IButton} props - Component properties.
 * @param {string} [props.className] - Additional classes for styling.
 * @param {ReactNode} props.children - Content to be rendered inside the button.
 * @param {MouseEventHandler<HTMLButtonElement>} props.onClick - Click event handler.
 * @returns {JSX.Element} Returns the JSX for the button.
 */

export const Button:FC<IButton> = ({className, type = 'button', children, onClick}):JSX.Element => {
  return  (
    <button onClick={onClick} type={type} className={`flex py-0.5 justify-center items-center rounded-[20px] border-none font-jostMedium text-base leading-[31px] cursor-pointer text-white ${className}`}>
      {children}
    </button>
  )
}